<template>
    <div>
        <ul class="rich-text-type">
            <li class="item">
                <input ref="file" type="file" class="input-file" @change="uploadChange" />
                <div class="hign-edit" style="width: 80px" @mousedown.prevent="uploadImg">
                    插入图片
                    <div class="icon icon1"></div>
                </div>
            </li>
            <li class="item">
                <div class="hign-edit" style="width: 100px" @mousedown.prevent="openFullEditor">
                    富文本编辑器
                    <div class="icon icon2"></div>
                </div>
            </li>
            <li class="item">
                <div class="hign-edit" style="width: 80px" @mousedown.prevent="insertQuote">
                    插入引用
                    <div class="icon icon3"></div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { ref } from "vue";

const props = defineProps(["editElement"]);
const emits = defineEmits(["operationDialog"]);

// 图片上传；
const file = ref(null);

function uploadChange(e) {
    // 前面做上传限制判断
    let reader = new FileReader();
    reader.onload = function (event) {
        let spanString = `<img src="${event.target.result}" style="max-width: 100%" />`;
        document.execCommand("insertHTML", false, spanString);
        props.editElement.blur();
    };
    reader.readAsDataURL(e.target.files[0]);
}
function uploadImg() {
    // 在上传之前线清空上一个文件
    file.value.value = "";
    file.value.click();
}
function openFullEditor(event) {
    emits("operationDialog", true);
}

function insertQuote(event) {}
</script>
<style lang="scss" scoped>
.rich-text-type {
    height: 43px;
    display: flex;
    z-index: 4;
    background-image: url(@/images/icon/Union@3x.png);
    background-size: 100% 100%;
    padding: 2px 5px;
    padding-top: 5px;
    color: rgba(112, 120, 134, 1);
    -webkit-user-select: none; /* 禁止 DIV 中的文本被鼠标选中 */
    -moz-user-select: none; /* 禁止 DIV 中的文本被鼠标选中 */
    -ms-user-select: none; /* 禁止 DIV 中的文本被鼠标选中 */
    user-select: none; /* 禁止 DIV 中的文本被鼠标选中 */
    li.item {
        min-width: 30px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        padding: 0 5px;
        position: relative;
        .hign-edit {
            padding-left: 19px;
            position: relative;
            font-size: 12px;
            .icon {
                width: 11px;
                height: 11px;
                position: absolute;
                top: 56%;
                left: 2px;
                transform: translateY(-50%);
                background-size: 100% 100%;
            }
            .icon1 {
                background-image: url(@/images/icon/tupian@3x.png);
            }
            .icon2 {
                background-image: url(@/images/icon/fuwenben@3x.png);
            }
            .icon3 {
                background-image: url(@/images/icon/yinyong@3x.png);
            }
        }
        .input-file {
            display: none;
        }
        &:hover {
            background-color: rgba(0, 0, 0, 0.1);
            cursor: pointer;
        }
    }
}
</style>
